import { render, staticRenderFns } from "./LoginRedirect.vue?vue&type=template&id=625ba79a&scoped=true"
import script from "./LoginRedirect.vue?vue&type=script&lang=js"
export * from "./LoginRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ba79a",
  null
  
)

export default component.exports